export var CHANGE_FAVORITE_AMOUNT = 'CHANGE_FAVORITE_AMOUNT';



// WEBPACK FOOTER //
// ./src/actions/favoriteAmounts.js